import { Stack, Slider, TextField } from "@fluentui/react"
import { Dispatch } from "react"
import { actionCreators } from "../../../../../../core/actions/configurator-actions"
import { IIdentificationConfig } from "@piceasoft/core"
import { strings } from "../../../../../../localization/strings"
import { onRenderLabel } from "../../../../../renders/onRenderLabel"
import { ParameterItem } from "../../../components/ParameterItem"
import { getSliderLabel } from "../../common/helpers/fuctions"
import { CheckProcessStageSectionOptionAccess } from "../../../helpers/evisibility";
import { ProcessStages } from "@piceasoft/core"

type TProps = {
    config: IIdentificationConfig
    onChangeDispatch: Dispatch<any>
    channel: number
}

export const IdentificationRequirementsPivot: React.FC<TProps> = ({ config, ...props }) => {
    return (
        <Stack.Item>
            <ParameterItem title={strings.CONSTRUCTOR.STAGES.COMMON.PIVOTS.ASSESSMENT_REQUIREMENTS.USE_REQUIREMENTS_TITLE}
                useToggle
                noSeparator
                toggleEnabled={CheckProcessStageSectionOptionAccess(props.channel, ProcessStages.Identification, 'Device Identifiers', 'Require device identifiers')}
                toggleChecked={config?.requirements ? true : false}
                toggleOnChange={() => {
                    props.onChangeDispatch(actionCreators.editStage(ProcessStages.Identification, {
                        ...config,
                        requirements: config?.requirements ? undefined : {}
                    } as IIdentificationConfig
                    ))
                }}
                description={strings.CONSTRUCTOR.STAGES.COMMON.PIVOTS.ASSESSMENT_REQUIREMENTS.USE_REQUIREMENTS_DESCRIPTION}
            />
            {config?.requirements && (
                <ParameterItem title={strings.CONSTRUCTOR.STAGES.COMMON.PIVOTS.ASSESSMENT_REQUIREMENTS.TITLE_TITLE}
                    useToggle
                    toggleEnabled={CheckProcessStageSectionOptionAccess(props.channel, ProcessStages.Identification, 'Device Identifiers', 'Use a custom title')}
                    toggleChecked={config?.ui?.requirements?.title !== undefined ? true : false}
                    toggleOnChange={() => {
                        props.onChangeDispatch(actionCreators.editStage(ProcessStages.Identification, {
                            ...config,
                            ui: {
                                ...config?.ui,
                                requirements: {
                                    ...config?.ui?.requirements,
                                    title: config?.ui?.requirements?.title !== undefined ? undefined : ""
                                }
                            }
                        } as IIdentificationConfig
                        ))
                    }}
                    description={strings.CONSTRUCTOR.STAGES.COMMON.PIVOTS.ASSESSMENT_REQUIREMENTS.TITLE_DESCRIPTION}
                    useTextField
                    textFieldValue={config.ui?.requirements?.title}
                    textFieldEnabled={config.ui?.requirements?.title !== undefined ? true : false}
                    textFieldOnChange={(val) => {
                        props.onChangeDispatch(actionCreators.editStage(ProcessStages.Identification, {
                            ...config,
                            ui: {
                                ...config?.ui,
                                requirements: {
                                    ...config?.ui?.requirements,
                                    title: val
                                }
                            }
                        } as IIdentificationConfig
                        ))
                    }}
                />
            )}
            {config?.requirements && (
                <ParameterItem title={strings.CONSTRUCTOR.STAGES.COMMON.PIVOTS.ASSESSMENT_REQUIREMENTS.INFORMATION_TITLE}
                    useToggle
                    toggleEnabled={CheckProcessStageSectionOptionAccess(props.channel, ProcessStages.Identification, 'Device Identifiers', 'Use custom information')}
                    toggleChecked={config?.ui?.requirements?.information !== undefined ? true : false}
                    toggleOnChange={() => {
                        props.onChangeDispatch(actionCreators.editStage(ProcessStages.Identification, {
                            ...config,
                            ui: {
                                ...config?.ui,
                                requirements: {
                                    ...config?.ui?.requirements,
                                    information: config?.ui?.requirements?.information !== undefined ? undefined : ""
                                }
                            }
                        } as IIdentificationConfig
                        ))
                    }}
                    description={strings.CONSTRUCTOR.STAGES.COMMON.PIVOTS.ASSESSMENT_REQUIREMENTS.INFORMATION_DESCRIPTION}
                    useTextField
                    textFieldEnabled={config.ui?.requirements?.information !== undefined ? true : false}
                    textFieldValue={config.ui?.requirements?.information}
                    textFieldOnChange={(val) => {
                        props.onChangeDispatch(actionCreators.editStage(ProcessStages.Identification, {
                            ...config,
                            ui: {
                                ...config?.ui,
                                requirements: {
                                    ...config?.ui?.requirements,
                                    information: val
                                }
                            }
                        } as IIdentificationConfig
                        ))
                    }}
                />
            )}
            {config?.requirements && (
                <ParameterItem title={strings.CONSTRUCTOR.STAGES.COMMON.PIVOTS.ASSESSMENT_REQUIREMENTS.IMEI.TITLE}
                    useToggle
                    toggleEnabled={CheckProcessStageSectionOptionAccess(props.channel, ProcessStages.Identification, 'Device Identifiers', 'Requires IMEI')}
                    toggleChecked={config?.requirements?.imei ? true : false}
                    toggleOnChange={() => {
                        props.onChangeDispatch(actionCreators.editStage(ProcessStages.Identification, {
                            ...config,
                            requirements: {
                                ...config?.requirements,
                                imei: config?.requirements?.imei ? undefined : {}
                            }
                        } as IIdentificationConfig
                        ))
                    }}
                    description={strings.CONSTRUCTOR.STAGES.COMMON.PIVOTS.ASSESSMENT_REQUIREMENTS.IMEI.DESCRIPTION}
                >
                    {config?.requirements?.imei && (
                        <Stack tokens={{ childrenGap: 16 }} style={{ width: 320 }}>
                            <TextField onRenderLabel={onRenderLabel} title={strings.CONSTRUCTOR.STAGES.COMMON.PIVOTS.ASSESSMENT_REQUIREMENTS.LABEL_TITLE}
                                label={strings.CONSTRUCTOR.STAGES.COMMON.PIVOTS.ASSESSMENT_REQUIREMENTS.LABEL} value={config?.requirements.imei.label ?? ""}
                                onChange={(ev, val) => props.onChangeDispatch(actionCreators.editStage(ProcessStages.Identification, {
                                    ...config,
                                    requirements: {
                                        ...config?.requirements,
                                        imei: {
                                            ...config?.requirements?.imei,
                                            label: (val && val.trim().length > 0) ? val : undefined
                                        }
                                    }
                                } as IIdentificationConfig
                                ))} />
                            <TextField onRenderLabel={onRenderLabel} title={strings.CONSTRUCTOR.STAGES.COMMON.PIVOTS.ASSESSMENT_REQUIREMENTS.PLACEHOLDER_TITLE}
                                label={strings.CONSTRUCTOR.STAGES.COMMON.PIVOTS.ASSESSMENT_REQUIREMENTS.PLACEHOLDER} value={config?.requirements.imei.placeholder ?? ""}
                                onChange={(ev, val) => props.onChangeDispatch(actionCreators.editStage(ProcessStages.Identification, {
                                    ...config,
                                    requirements: {
                                        ...config?.requirements,
                                        imei: {
                                            ...config?.requirements?.imei,
                                            placeholder: (val && val.trim().length > 0) ? val : undefined
                                        }
                                    }
                                } as IIdentificationConfig
                                ))} />
                            <TextField onRenderLabel={onRenderLabel} title={strings.CONSTRUCTOR.STAGES.COMMON.PIVOTS.ASSESSMENT_REQUIREMENTS.MASK_TITLE}
                                label={strings.CONSTRUCTOR.STAGES.COMMON.PIVOTS.ASSESSMENT_REQUIREMENTS.MASK} value={config?.requirements.imei.mask ?? ""}
                                onChange={(ev, val) => props.onChangeDispatch(actionCreators.editStage(ProcessStages.Identification, {
                                    ...config,
                                    requirements: {
                                        ...config?.requirements,
                                        imei: {
                                            ...config?.requirements?.imei,
                                            mask: (val && val.trim().length > 0) ? val : undefined
                                        }
                                    }
                                } as IIdentificationConfig
                                ))} />
                            <Stack.Item>
                                {onRenderLabel({
                                    label: getSliderLabel(config.requirements.imei.minLength, config.requirements.imei.maxLength),
                                    title: strings.CONSTRUCTOR.STAGES.COMMON.PIVOTS.ASSESSMENT_REQUIREMENTS.LENGHT_TITLE
                                })}
                                <Slider showValue={false} ranged lowerValue={config.requirements.imei.minLength}
                                    value={config.requirements.imei.maxLength} onChange={(val, range) => {
                                        props.onChangeDispatch(actionCreators.editStage(ProcessStages.Identification, {
                                            ...config,
                                            requirements: {
                                                ...config?.requirements,
                                                imei: {
                                                    ...config?.requirements?.imei,
                                                    minLength: range && range[0] !== 0 && range[0] || undefined,
                                                    maxLength: range && range[1] !== 0 && range[1] || undefined
                                                }
                                            }
                                        } as IIdentificationConfig
                                        ))
                                    }} min={0} max={50} />
                            </Stack.Item>
                        </Stack>
                    )}
                </ParameterItem>
            )}
            {config?.requirements && (
                <ParameterItem title={strings.CONSTRUCTOR.STAGES.COMMON.PIVOTS.ASSESSMENT_REQUIREMENTS.IMEI2.TITLE}
                    useToggle
                    toggleEnabled={CheckProcessStageSectionOptionAccess(props.channel, ProcessStages.Identification, 'Device Identifiers', 'Requires IMEI2')}
                    toggleChecked={config?.requirements?.imei2 ? true : false}
                    toggleOnChange={() => {
                        props.onChangeDispatch(actionCreators.editStage(ProcessStages.Identification, {
                            ...config,
                            requirements: {
                                ...config?.requirements,
                                imei2: config?.requirements?.imei2 ? undefined : {}
                            }
                        } as IIdentificationConfig
                        ))
                    }}
                    description={strings.CONSTRUCTOR.STAGES.COMMON.PIVOTS.ASSESSMENT_REQUIREMENTS.IMEI2.DESCRIPTION}
                >
                    {config?.requirements?.imei2 && (
                        <Stack tokens={{ childrenGap: 16 }} style={{ width: 320 }}>
                            <TextField onRenderLabel={onRenderLabel} title={strings.CONSTRUCTOR.STAGES.COMMON.PIVOTS.ASSESSMENT_REQUIREMENTS.LABEL_TITLE}
                                label={strings.CONSTRUCTOR.STAGES.COMMON.PIVOTS.ASSESSMENT_REQUIREMENTS.LABEL} value={config?.requirements.imei2.label ?? ""}
                                onChange={(ev, val) => props.onChangeDispatch(actionCreators.editStage(ProcessStages.Identification, {
                                    ...config,
                                    requirements: {
                                        ...config?.requirements,
                                        imei2: {
                                            ...config?.requirements?.imei2,
                                            label: (val && val.trim().length > 0) ? val : undefined
                                        }
                                    }
                                } as IIdentificationConfig
                                ))} />
                            <TextField onRenderLabel={onRenderLabel} title={strings.CONSTRUCTOR.STAGES.COMMON.PIVOTS.ASSESSMENT_REQUIREMENTS.PLACEHOLDER_TITLE}
                                label={strings.CONSTRUCTOR.STAGES.COMMON.PIVOTS.ASSESSMENT_REQUIREMENTS.PLACEHOLDER} value={config?.requirements.imei2.placeholder ?? ""}
                                onChange={(ev, val) => props.onChangeDispatch(actionCreators.editStage(ProcessStages.Identification, {
                                    ...config,
                                    requirements: {
                                        ...config?.requirements,
                                        imei2: {
                                            ...config?.requirements?.imei2,
                                            placeholder: (val && val.trim().length > 0) ? val : undefined
                                        }
                                    }
                                } as IIdentificationConfig
                                ))} />
                            <TextField onRenderLabel={onRenderLabel} title={strings.CONSTRUCTOR.STAGES.COMMON.PIVOTS.ASSESSMENT_REQUIREMENTS.MASK_TITLE}
                                label={strings.CONSTRUCTOR.STAGES.COMMON.PIVOTS.ASSESSMENT_REQUIREMENTS.MASK} value={config?.requirements.imei2.mask ?? ""}
                                onChange={(ev, val) => props.onChangeDispatch(actionCreators.editStage(ProcessStages.Identification, {
                                    ...config,
                                    requirements: {
                                        ...config?.requirements,
                                        imei2: {
                                            ...config?.requirements?.imei2,
                                            mask: (val && val.trim().length > 0) ? val : undefined
                                        }
                                    }
                                } as IIdentificationConfig
                                ))} />
                            <Stack.Item>
                                {onRenderLabel({
                                    label: getSliderLabel(config.requirements.imei2.minLength, config.requirements.imei2.maxLength),
                                    title: strings.CONSTRUCTOR.STAGES.COMMON.PIVOTS.ASSESSMENT_REQUIREMENTS.LENGHT_TITLE
                                })}
                                <Slider showValue={false} ranged lowerValue={config.requirements.imei2.minLength}
                                    value={config.requirements.imei2.maxLength} onChange={(val, range) => {
                                        props.onChangeDispatch(actionCreators.editStage(ProcessStages.Identification, {
                                            ...config,
                                            requirements: {
                                                ...config?.requirements,
                                                imei2: {
                                                    ...config?.requirements?.imei2,
                                                    minLength: range && range[0] !== 0 && range[0] || undefined,
                                                    maxLength: range && range[1] !== 0 && range[1] || undefined
                                                }
                                            }
                                        } as IIdentificationConfig
                                        ))
                                    }} min={0} max={50} />
                            </Stack.Item>
                        </Stack>
                    )}
                </ParameterItem>
            )}
            {config?.requirements && (
                <ParameterItem title={strings.CONSTRUCTOR.STAGES.COMMON.PIVOTS.ASSESSMENT_REQUIREMENTS.SN.TITLE}
                    useToggle
                    toggleEnabled={CheckProcessStageSectionOptionAccess(props.channel, ProcessStages.Identification, 'Device Identifiers', 'Requires serial number')}
                    toggleChecked={config?.requirements?.sn ? true : false}
                    toggleOnChange={() => {
                        props.onChangeDispatch(actionCreators.editStage(ProcessStages.Identification, {
                            ...config,
                            requirements: {
                                ...config?.requirements,
                                sn: config?.requirements?.sn ? undefined : {}
                            }
                        } as IIdentificationConfig
                        ))
                    }}
                    description={strings.CONSTRUCTOR.STAGES.COMMON.PIVOTS.ASSESSMENT_REQUIREMENTS.SN.DESCRIPTION}
                >
                    {config?.requirements?.sn && (
                        <Stack tokens={{ childrenGap: 16 }} style={{ width: 320 }}>
                            <TextField onRenderLabel={onRenderLabel} title={strings.CONSTRUCTOR.STAGES.COMMON.PIVOTS.ASSESSMENT_REQUIREMENTS.LABEL_TITLE}
                                label={strings.CONSTRUCTOR.STAGES.COMMON.PIVOTS.ASSESSMENT_REQUIREMENTS.LABEL} value={config?.requirements.sn.label ?? ""}
                                onChange={(ev, val) => props.onChangeDispatch(actionCreators.editStage(ProcessStages.Identification, {
                                    ...config,
                                    requirements: {
                                        ...config?.requirements,
                                        sn: {
                                            ...config?.requirements?.sn,
                                            label: (val && val.trim().length > 0) ? val : undefined
                                        }
                                    }
                                } as IIdentificationConfig
                                ))} />
                            <TextField onRenderLabel={onRenderLabel} title={strings.CONSTRUCTOR.STAGES.COMMON.PIVOTS.ASSESSMENT_REQUIREMENTS.PLACEHOLDER_TITLE}
                                label={strings.CONSTRUCTOR.STAGES.COMMON.PIVOTS.ASSESSMENT_REQUIREMENTS.PLACEHOLDER} value={config?.requirements.sn.placeholder ?? ""}
                                onChange={(ev, val) => props.onChangeDispatch(actionCreators.editStage(ProcessStages.Identification, {
                                    ...config,
                                    requirements: {
                                        ...config?.requirements,
                                        sn: {
                                            ...config?.requirements?.sn,
                                            placeholder: (val && val.trim().length > 0) ? val : undefined
                                        }
                                    }
                                } as IIdentificationConfig
                                ))} />
                            <TextField onRenderLabel={onRenderLabel} title={strings.CONSTRUCTOR.STAGES.COMMON.PIVOTS.ASSESSMENT_REQUIREMENTS.MASK_TITLE}
                                label={strings.CONSTRUCTOR.STAGES.COMMON.PIVOTS.ASSESSMENT_REQUIREMENTS.MASK} value={config?.requirements.sn.mask ?? ""}
                                onChange={(ev, val) => props.onChangeDispatch(actionCreators.editStage(ProcessStages.Identification, {
                                    ...config,
                                    requirements: {
                                        ...config?.requirements,
                                        sn: {
                                            ...config?.requirements?.sn,
                                            mask: (val && val.trim().length > 0) ? val : undefined
                                        }
                                    }
                                } as IIdentificationConfig
                                ))} />
                            <Stack.Item>
                                {onRenderLabel({
                                    label: getSliderLabel(config.requirements.sn.minLength, config.requirements.sn.maxLength),
                                    title: strings.CONSTRUCTOR.STAGES.COMMON.PIVOTS.ASSESSMENT_REQUIREMENTS.LENGHT_TITLE
                                })}
                                <Slider
                                    showValue={false} ranged lowerValue={config.requirements.sn.minLength}
                                    value={config.requirements.sn.maxLength} onChange={(val, range) => {
                                        props.onChangeDispatch(actionCreators.editStage(ProcessStages.Identification, {
                                            ...config,
                                            requirements: {
                                                ...config?.requirements,
                                                sn: {
                                                    ...config?.requirements?.sn,
                                                    minLength: range && range[0] !== 0 && range[0] || undefined,
                                                    maxLength: range && range[1] !== 0 && range[1] || undefined
                                                }
                                            }
                                        } as IIdentificationConfig
                                        ))
                                    }} min={0} max={50} />
                            </Stack.Item>
                        </Stack>
                    )}
                </ParameterItem>
            )}
            <ParameterItem title={strings.CONSTRUCTOR.STAGES.COMMON.PIVOTS.ASSESSMENT_REQUIREMENTS.CONFIRM_DEVICE_ATTRIBUTES_TITLE}
                useToggle
                noSeparator
                toggleEnabled={CheckProcessStageSectionOptionAccess(props.channel, ProcessStages.Identification, 'Device Attributes', 'Confirm attributes')}
                toggleChecked={config?.confirmDeviceAttributes ? true : false}
                toggleOnChange={() => {
                    props.onChangeDispatch(actionCreators.editStage(ProcessStages.Identification, {
                        ...config,
                        confirmDeviceAttributes: config?.confirmDeviceAttributes ? undefined : {}
                    } as IIdentificationConfig
                    ))
                }}
                description={strings.CONSTRUCTOR.STAGES.COMMON.PIVOTS.ASSESSMENT_REQUIREMENTS.CONFIRM_DEVICE_ATTRIBUTES_DESCRIPTION}
            />
            {config?.confirmDeviceAttributes && (
                <ParameterItem title={strings.CONSTRUCTOR.STAGES.COMMON.PIVOTS.ASSESSMENT_REQUIREMENTS.DEVICE_COLOR_ATTRIBUTE.TITLE}
                    useToggle
                    toggleEnabled={CheckProcessStageSectionOptionAccess(props.channel, ProcessStages.Identification, 'Device Attributes', 'Confirm color')}
                    toggleChecked={config?.confirmDeviceAttributes?.confirmColor ? true : false}
                    toggleOnChange={() => {
                        props.onChangeDispatch(actionCreators.editStage(ProcessStages.Identification, {
                            ...config,
                            confirmDeviceAttributes: {
                                ...config?.confirmDeviceAttributes,
                                confirmColor: config?.confirmDeviceAttributes?.confirmColor ? undefined : true
                            }
                        } as IIdentificationConfig
                        ))
                    }}
                    description={strings.CONSTRUCTOR.STAGES.COMMON.PIVOTS.ASSESSMENT_REQUIREMENTS.DEVICE_COLOR_ATTRIBUTE.DESCRIPTION}
                />
            )}
            {config?.confirmDeviceAttributes && (
                <ParameterItem title={strings.CONSTRUCTOR.STAGES.COMMON.PIVOTS.ASSESSMENT_REQUIREMENTS.DEVICE_GLASS_ATTRIBUTE.TITLE}
                    useToggle
                    toggleEnabled={CheckProcessStageSectionOptionAccess(props.channel, ProcessStages.Identification, 'Device Attributes', 'Confirm glass')}
                    toggleChecked={config?.confirmDeviceAttributes?.confirmGlass ? true : false}
                    toggleOnChange={() => {
                        props.onChangeDispatch(actionCreators.editStage(ProcessStages.Identification, {
                            ...config,
                            confirmDeviceAttributes: {
                                ...config?.confirmDeviceAttributes,
                                confirmGlass: config?.confirmDeviceAttributes?.confirmGlass ? undefined : true
                            }
                        } as IIdentificationConfig
                        ))
                    }}
                    description={strings.CONSTRUCTOR.STAGES.COMMON.PIVOTS.ASSESSMENT_REQUIREMENTS.DEVICE_GLASS_ATTRIBUTE.DESCRIPTION}
                />
            )}
            
        </Stack.Item>
    )
}